import { render } from "./BudgetProcessGroupDialog.vue?vue&type=template&id=709835d4&scoped=true"
import script from "./BudgetProcessGroupDialog.vue?vue&type=script&lang=js"
export * from "./BudgetProcessGroupDialog.vue?vue&type=script&lang=js"

import "./BudgetProcessGroupDialog.vue?vue&type=style&index=0&id=709835d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709835d4"]])

export default __exports__